import React from 'react';
import PropTypes from 'prop-types';

const ImagePopup = ({ imageUrl }) => {
  return <img src={imageUrl} alt="product_image" />;
};

export default ImagePopup;

ImagePopup.propTypes = {
  imageUrl: PropTypes.string.isRequired
};
